import { Box} from "@chakra-ui/react";
import PrivateContentLayout from "../Common/PrivateContentLayout";
import ChangePassword from "../Common/ChangePassword";
import SuperuserSideBar from "../Components/SuperuserSideBar";


interface ChangePasswordProps {
  handleLogout: () => void; // Pass the handleLogout function as a prop
}

const ChangePasswordSuper = ({ handleLogout }: ChangePasswordProps) => {
  
  return (
   
    <Box>
        <SuperuserSideBar />
        <PrivateContentLayout>
        <ChangePassword handleLogout={handleLogout} />
        </PrivateContentLayout>
    </Box>
  );
};

export default ChangePasswordSuper;
